module.exports = __webpack_public_path__ + "static/media/ukAnli6.de507324.jpg";